import type { AnyRouter } from '@tanstack/react-router';

/**
 * Toggles `nav-forward`/`nav-back` on <html> before each navigation so the
 * directional slide keyframes in globals.css (keyed on those classes) fire.
 * Direction is derived from path-prefix comparison rather than the raw
 * history action, so a "Cancel" button pushing back to a parent path still
 * slides as "back" even though it's technically a history PUSH.
 */
export function setupNavTransitionClasses(router: AnyRouter) {
  return router.subscribe('onBeforeNavigate', ({ fromLocation, toLocation }) => {
    if (!fromLocation) return;

    const from = fromLocation.pathname;
    const to = toLocation.pathname;
    if (from === to) return;

    const isBack = from.length > to.length && from.startsWith(to);
    const classList = document.documentElement.classList;
    classList.remove('nav-forward', 'nav-back');
    classList.add(isBack ? 'nav-back' : 'nav-forward');
  });
}
